<template>
  <div class="formSetting">
    <el-collapse v-model="activeNames" accordion>
      <el-collapse-item title="表单项" name="1">
        <div style="padding: 20px;">
          <el-collapse class="form_item" accordion>
            <el-collapse-item title="姓名" name="1">
              <ul class="settingUl">
                <li>
                  <span>名称</span>
                  <el-input style="width: 250px;" v-model="data.form.name.title" placeholder="请输入内容"
                    size="small"></el-input>
                </li>
                <li>
                  <span>提示文字</span>
                  <el-input style="width: 250px;" v-model="data.form.name.tipTxt" placeholder="请输入内容"
                    size="small"></el-input>
                </li>
                <li>
                  <span>必填项</span>
                  <el-switch v-model="value1" disabled>
                  </el-switch>
                </li>
                <li>
                  <span>必填错误提示</span>
                  <el-input style="width: 250px;" v-model="data.form.name.errTxt" placeholder="请输入内容"
                    size="small"></el-input>
                </li>
              </ul>
            </el-collapse-item>
            <el-collapse-item title="电话" name="2">
              <ul class="settingUl">
                <li>
                  <span>名称</span>
                  <el-input style="width: 250px;" v-model="data.form.phone.title" placeholder="请输入内容"
                    size="small"></el-input>
                </li>
                <li>
                  <span>提示文字</span>
                  <el-input style="width: 250px;" v-model="data.form.phone.tipTxt" placeholder="请输入内容"
                    size="small"></el-input>
                </li>
                <li>
                  <span>必填项</span>
                  <el-switch v-model="value1" disabled>
                  </el-switch>
                </li>
                <li>
                  <span>必填错误提示</span>
                  <el-input style="width: 250px;" v-model="data.form.phone.errTxt" placeholder="请输入内容"
                    size="small"></el-input>
                </li>
                <li>
                  <span>验证错误提示</span>
                  <el-input style="width: 250px;" v-model="data.form.phone.yzErr" placeholder="请输入内容"
                    size="small"></el-input>
                </li>
              </ul>
            </el-collapse-item>
            <el-collapse-item v-for="(item, index) in data.form.content" :name="3 + index" class="content_coll"
              :key="index">
              <template slot="title">
                <div class="con_title">
                  <span>内容</span>
                  <el-button size="small" icon="el-icon-close" type="info" plain>
                  </el-button>
                </div>
              </template>
              <ul class="settingUl">
                <li>
                  <span>类型</span>
                  <el-select v-model="item.type" placeholder="请选择" size="small">
                    <el-option v-for="item1 in options" :key="item1.value" :label="item1.label" :value="item1.value">
                    </el-option>
                  </el-select>
                </li>
                <li>
                  <span>名称</span>
                  <el-input style="width: 250px;" v-model="item.title" placeholder="请输入内容" size="small"></el-input>
                </li>
                <li>
                  <span>提示文字</span>
                  <el-input style="width: 250px;" v-model="item.tipTxt" placeholder="请输入内容" size="small"></el-input>
                </li>
                <li>
                  <span>必填项</span>
                  <el-switch v-model="item.visible">
                  </el-switch>
                </li>
                <li v-if="item.type === '3' || item.type === '4' || item.type === '5'">
                  <span>选项</span>
                </li>
                <li v-for="(item1, idx) in item.radioMap" :key="idx" v-if="item.type === '3'">
                  <el-checkbox v-model="item1.checkd" @change="hanleCheck(item, item1, idx)">默认</el-checkbox>
                  <el-input v-model="item1.text" placeholder="请输入内容" size="small" style="width: 300px;"></el-input>
                  <i class="xuanxDel el-icon-close" @click="handleRemove(item, idx)"></i>
                </li>
                <li v-for="(item2, idx) in item.groups" :key="idx" v-if="item.type === '4'">
                  <el-checkbox v-model="item2.checkd" @change="hanleCheck(item, item2, idx)">默认</el-checkbox>
                  <el-input v-model="item2.text" placeholder="请输入内容" size="small" style="width: 300px;"></el-input>
                  <i class="xuanxDel el-icon-close" @click="handleRemove(item, idx)"></i>
                </li>
                <li v-for="(item3, idx) in item.selectOptions" :key="idx" v-if="item.type === '5'">
                  <el-checkbox v-model="item3.checkd" @change="hanleCheck(item, item3, idx)">默认</el-checkbox>
                  <el-input v-model="item3.text" placeholder="请输入内容" size="small" style="width: 300px;"></el-input>
                  <i class="xuanxDel el-icon-close" @click="handleRemove(item, idx)"></i>
                </li>
                <li v-if="item.type === '3' || item.type === '4' || item.type === '5'">
                  <el-button type="primary" plain style="width: 100%;" size="small"
                    @click="handleAdd(item)">添加选项</el-button>
                </li>
                <li v-if="item.visible">
                  <span>必填错误提示</span>
                  <el-input style="width: 250px;" v-model="item.errTxt" placeholder="请输入内容" size="small"></el-input>
                </li>
                <li v-if="item.type === '6'">
                  <span>验证错误提示</span>
                  <el-input style="width: 250px;" v-model="item.emailErr" placeholder="请输入内容" size="small"></el-input>
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
          <el-button type="primary" style="width: 100%;" size="small" @click="handleFormAdd">添加表单控件</el-button>
          <ul class="settingUl">
            <li>
              <span>按钮名称</span>
              <el-input style="width: 250px;" maxlength="8" show-word-limit v-model="data.form.btnName"
                placeholder="请输入内容"></el-input>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item title="表单信息" name="2">
        <ul class="settingUl">
          <li>
            <span>短信通知</span>
            <el-switch v-model="msgValue">
            </el-switch>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="内容样式" name="3">
        <ul class="settingUl">
          <li>
            <span>标题</span>
            <el-switch v-model="data.form.titleValue">
            </el-switch>
          </li>
          <li>
            <span>样式</span>
            <el-radio-group v-model="data.form.inputStyle" size="mini">
              <el-radio-button label="描边"></el-radio-button>
              <el-radio-button label="填充"></el-radio-button>
            </el-radio-group>
          </li>
          <li v-if="data.form.inputStyle === '描边'">
            <span>描边颜色</span>
            <el-color-picker v-model="data.form.mbColor"></el-color-picker>
          </li>
          <li v-if="data.form.inputStyle === '填充'">
            <span>填充颜色</span>
            <el-color-picker v-model="data.form.tcColor"></el-color-picker>
          </li>
          <li>
            <span>按钮颜色</span>
            <el-color-picker v-model="data.form.btnColor"></el-color-picker>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="组件样式" name="4">
        <comSetting :infoItme="data.infoItme" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import comSetting from '../comSetting'

export default {
  name: 'formSetting',
  components: { comSetting },
  props: {
    data: Object
  },
  data () {
    return {
      activeNames: ['1'],
      btnVal: '',
      value1: true,
      msgValue: false,
      options: [
        {
          value: '1',
          label: '多行文本框'
        },
        {
          value: '2',
          label: '单行文本框'
        },
        {
          value: '3',
          label: '单选按钮'
        },
        {
          value: '4',
          label: '多选按钮'
        },
        {
          value: '5',
          label: '下拉框'
        },
        {
          value: '6',
          label: '邮箱'
        }
      ]
    }
  },
  methods: {
    hanleCheck (item, item1, index) {
      console.log('默认', item, item1, index)
      if (item.type === '4') {
        if (item1.checkd) {
          item.checkboxGroup.push(item1.value)
        } else {
          item.checkboxGroup = item.checkboxGroup.filter(
            i => i !== item1.value
          )
          //   item.checkboxGroup.splice(index, 1);
        }
      }
      if (item.type === '3') {
        if (item1.checkd) {
          item.radioVal = index + 1
          item.radioMap.map((i, idx) => {
            if (idx !== index) {
              i.checkd = false
            }
          })
        } else {
          item.radioVal = 0
        }
      }
      if (item.type === '5') {
        if (item1.checkd) {
          item.selectVal = item1.value
          item.selectOptions.map((i, idx) => {
            if (idx !== index) {
              i.checkd = false
            }
          })
        } else {
          item.selectVal = ''
        }
      }
    },
    handleRemove (item, index) {
      if (item.type === '4') {
        item.groups.splice(index, 1)
        return
      }
      if (item.type === '5') {
        item.selectOptions.splice(index, 1)
        return
      }
      item.radioMap.splice(index, 1)
    },
    handleAdd (item) {
      if (item.type === '4') {
        item.groups.push({
          text: `新选项${item.groups.length + 1}`,
          value: item.groups.length + 1,
          checkd: false
        })
        return
      }
      if (item.type === '5') {
        item.selectOptions.push({
          text: `新选项${item.selectOptions.length + 1}`,
          value: item.selectOptions.length + 1,
          checkd: false
        })
        return
      }
      item.radioMap.push({
        text: `新选项${item.radioMap.length + 1}`,
        value: item.radioMap.length + 1,
        checkd: false
      })
    },
    handleFormAdd () {
      console.log('添加表单控件', this.data.form.content, {
        ...this.data.form.content
      })
      this.data.form.content.push({
        type: '1',
        title: '内容',
        tipTxt: '请输入您的留言内容',
        visible: false,
        errTxt: '此项必填',
        radioVal: 0,
        selectVal: '',
        checkboxGroup: [],
        emailErr: '邮箱格式不正确',
        groups: [
          {
            title: '选项一',
            label: 1,
            checkd: false
          },
          {
            title: '选项二',
            label: 2,
            checkd: false
          },
          {
            title: '选项三',
            label: 3,
            checkd: false
          }
        ],
        radioMap: [
          {
            title: '选项一',
            label: 1,
            checkd: false
          },
          {
            title: '选项二',
            label: 2,
            checkd: false
          },
          {
            title: '选项三',
            label: 3,
            checkd: false
          }
        ],
        selectOptions: [
          {
            value: '1',
            label: '选项一',
            checkd: false
          },
          {
            value: '2',
            label: '选项二',
            checkd: false
          },
          {
            value: '3',
            label: '选项三',
            checkd: false
          }
        ]
      })
    }
  },
  mounted () {
    console.log(this.data)
  }
}
</script>

<style scoped>
.formSetting {
  padding: 10px;
}

.form_item {
  border: none;
}

.form_item .el-collapse-item {
  border: 1px solid #e1e4eb;
  margin-bottom: 15px;
  border-radius: 4px;
}

/deep/ .form_item .el-collapse-item .el-collapse-item__header {
  border-bottom-color: transparent;
  height: 32px;
  font-size: 12px;
  color: #516280;
  line-height: 32px;
  background-color: #f7f9fb;
  margin: 0;
  padding-left: 10px;
}

/deep/ .form_item .el-collapse-item__content {
  padding: 15px;
}

/deep/ .form_item .el-collapse-item__wrap {
  border: none;
}

/deep/ .content_coll .el-collapse-item__arrow {
  display: none;
}

.content_coll .con_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.content_coll .con_title .el-button {
  border: none;
  background: #f7f9fb;
  color: #909399;
  border-left: 1px solid #e1e4eb;
}

.xuanxDel {
  font-size: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/form/formSetting.vue